import { isValidCNPJ, isValidCPF } from '@brazilian-utils/brazilian-utils';
import { DocType } from '../constants/entity';

export const docTypeFromStr = (doc: string): DocType | null => {
    if (isValidCNPJ(doc)) return 'CNPJ';
    if (isValidCPF(doc)) return 'CPF';
    return null;
};
